import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "postal-card-preview",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToDetail && _ctx.goToDetail(...args)))
  }, [
    _createElementVNode("img", {
      src: _ctx.card.image,
      alt: _ctx.card.title
    }, null, 8, _hoisted_1)
  ]))
}